import { App } from './App'
import { Provider } from 'react-redux'
import store, { persistor } from '../store'
import { PersistGate } from 'redux-persist/integration/react'
import { CustomIntlProvider } from '../providers/intl'
import { Router } from 'react-router-dom'
import history from '../history'
import { ErrorBoundary } from './ErrorBoundary'
import { useState } from 'react'
import { AmpliProvider } from '../providers/amplitude'
import { LegacyThemeProvider } from '@homebot/shared-ui-swashbuckle'

export const AppContainer = () => {
  const [isError, setIsError] = useState(false)
  return (
    <ErrorBoundary setIsError={setIsError}>
      <Provider store={store}>
        <LegacyThemeProvider>
          <PersistGate loading={null} persistor={persistor}>
            <CustomIntlProvider>
              <AmpliProvider>
                <Router history={history}>
                  <App error={isError} />
                </Router>
              </AmpliProvider>
            </CustomIntlProvider>
          </PersistGate>
        </LegacyThemeProvider>
      </Provider>
    </ErrorBoundary>
  )
}
